export const EMAILJS_SERVICE_ID = "service_38e5nra";
export const EMAILJS_TEMPLATE_ID = "template_ouvjjei";
export const EMAILJS_PUBLIC_KEY = "sRU9UqV8gWXEwUw5T";
